






















import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class ConfirmDialog extends Vue {
  @Prop() showConfirmDialog!: boolean;
  @Prop({ default: "aceptar" }) aceptarButtonName!: string;
  @Prop({ default: "cancelar" }) cancelarButtonName!: string;
  @Prop({ default: 30 }) percentWidth!: number;
  @Prop({ default: true }) retainFocus!: boolean;

  public AceptarAction() {
    this.$emit("AceptarEvent");
  }

  public CancelarAction() {
    this.$emit("CancelarEvent");
  }

  public get getWidth() {
    return this.percentWidth.toString() + "%";
  }
}
